import React from 'react';
import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import ProductsScreen from '../components/ProductsScreen';
import { useApp } from '../context/AppContext';

const ProductsPage = () => {
  const navigate = useNavigate();
  const { currentUser } = useApp();

  // Redirecionar para a página inicial se não houver usuário logado
  React.useEffect(() => {
    if (!currentUser) {
      navigate('/');
    }
  }, [currentUser, navigate]);

  const handleBack = () => {
    navigate('/menu'); // Navega diretamente para o Menu Principal
  };

  return (
    <Box height="100vh" width="100%" bg="black">
      <ProductsScreen onBack={handleBack} />
    </Box>
  );
};

export default ProductsPage;
